import React from "react";

import cx from "classnames";

import styles from "./css/TextArea.module.css";

type Props = React.HTMLProps<HTMLTextAreaElement> & {
	resizable?: boolean;
	error?: boolean;
};

const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(
	({ className, resizable, error, ...textAreaProps }: Props, ref) => {
		return (
			<textarea
				ref={ref}
				className={cx(styles.textArea, className, { [styles.resizable]: resizable, [styles.error]: error })}
				{...textAreaProps}
			/>
		);
	},
);
TextArea.displayName = "TextArea";

export default TextArea;
